import { render, staticRenderFns } from "./dragTable.vue?vue&type=template&id=3a72e296&scoped=true"
import script from "./dragTable.vue?vue&type=script&lang=js"
export * from "./dragTable.vue?vue&type=script&lang=js"
import style0 from "./dragTable.vue?vue&type=style&index=0&id=3a72e296&prod&lang=css"
import style1 from "./dragTable.vue?vue&type=style&index=1&id=3a72e296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72e296",
  null
  
)

export default component.exports